import Decimal from "decimal.js";
import Itinerary from "../Itinerary";
import { ReservationCustomer } from "./ReservationCustomer";
import { PaymentAllocationCategoryItem } from "./PaymentAllocationCategoryItem";
import ReservationGuest from "./ReservationGuest";

export class PaymentAllocationCategory {
  paymentAllocationCategoryId!: number;
  reservationId!: number;
  categoryName!: string;
  allocationItems!: PaymentAllocationCategoryItem[];
  allocationLines?: number;

  static getCost(allocationCategory: PaymentAllocationCategory | undefined, itinerary: Itinerary, reservationGuestsCount: number): number {
    if (!!!allocationCategory || allocationCategory.categoryName === "Even Split" || !allocationCategory.allocationLines) return 0.0;

    let cost: number = 0.0;

    if (itinerary.lodgingItineraries && itinerary.lodgingItineraries.length > 0) {
      itinerary.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
        const allocationItem = allocationCategory.allocationItems.find(ai => ai.itineraryUnitId === u.id && !u.cancelled)
        if (allocationItem != undefined) {
          if (allocationItem.evenSplit) {
            let price = new Decimal(u.sell).dividedBy(reservationGuestsCount);
            price = price.mul(allocationCategory.allocationLines || 1); // doing this because later we divide the cost by how many people have this allocation

            cost += price.toNumber();
            return;
          }

          if (allocationItem.numberGuestsPayingFor === 0 || allocationItem.numberUnitsPayingFor === 0) return;

          const perUnitPrice = new Decimal(u.sell).dividedBy(u.numberOfUnits);
          const unitsPayingFor = allocationItem.numberUnitsPayingFor > 0 ? allocationItem.numberUnitsPayingFor : u.numberOfUnits;
          const priceOfUnits = perUnitPrice.mul(unitsPayingFor);

          const guestsPayingFor = allocationItem.numberGuestsPayingFor > 0 ? allocationItem.numberGuestsPayingFor : 1;
          const perGuestPrice = priceOfUnits.dividedBy(allocationItem.numberUnitsPayingFor > 0 ? guestsPayingFor : u.numberOfGuests);

          cost += perGuestPrice.mul(guestsPayingFor).toNumber();
        }
      }));
    }

    if (itinerary.golfItineraries && itinerary.golfItineraries.length > 0) {
      itinerary.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
        const allocationItem = allocationCategory.allocationItems.find(ai => ai.itineraryUnitId === u.id && !u.cancelled)
        if (allocationItem != undefined) {
          const perPlayerPrice = new Decimal(u.sell).dividedBy(u.numberOfGuests);

          cost += perPlayerPrice.mul(allocationItem.numberGuestsPayingFor).toNumber();
        }
      }))
    }

    if (itinerary.transportItineraries && itinerary.transportItineraries.length > 0) {
      itinerary.transportItineraries.forEach(i => i.itineraryUnits.forEach(u => {
        const allocationItem = allocationCategory.allocationItems.find(ai => ai.itineraryUnitId === u.id && !u.cancelled)
        if (allocationItem != undefined) {
          if (allocationItem.evenSplit) {
            let price = new Decimal(u.sell).dividedBy(reservationGuestsCount);
            price = price.mul(allocationCategory.allocationLines || 1); // doing this because later we divide the cost by how many people have this allocation

            cost += price.toNumber();
            return;
          }

          if (allocationItem.numberGuestsPayingFor === 0 || allocationItem.numberUnitsPayingFor === 0) return;

          const perUnitPrice = new Decimal(u.sell).add(u.tax1).dividedBy(u.numberOfUnits);
          const perGuestPrice = new Decimal(u.sell).add(u.tax1).dividedBy(u.numberOfGuests);
          const unitsPayingFor = allocationItem.numberUnitsPayingFor > 0 ? allocationItem.numberUnitsPayingFor : 1;
          const guestsPayingFor = allocationItem.numberGuestsPayingFor > 0 ? allocationItem.numberGuestsPayingFor : 1;

          // cost += perUnitPrice.mul(unitsPayingFor).toNumber();
          cost += perGuestPrice.mul(guestsPayingFor).toNumber();
        }
      }))
    }

    if (itinerary.customItineraries && itinerary.customItineraries.length > 0) {
      itinerary.customItineraries.forEach(i => i.itineraryUnits.forEach(u => {
        const allocationItem = allocationCategory.allocationItems.find(ai => ai.itineraryUnitId === u.id && !u.cancelled)
        if (allocationItem != undefined) {
          const perUnitPrice = new Decimal(u.sell).add(u.tax1).dividedBy(u.numberOfUnits);

          cost += perUnitPrice.mul(allocationItem.numberUnitsPayingFor).toNumber();
        }
      }))
    }

    if (itinerary.adjustments && itinerary.adjustments.length > 0) {
      itinerary.adjustments.forEach(u => {
        const allocationItem = allocationCategory.allocationItems.find(ai => ai.adjustmentId === u.id && !u.cancelled)
        if (allocationItem != undefined) {
          if (allocationItem.evenSplit) {
            let price = new Decimal(u.sell).dividedBy(u.numUnits);
            price = price.mul(allocationCategory.allocationLines || 1); // doing this because later we divide the cost by how many people have this allocation

            cost += price.toNumber();
            return;
          }

          const perUnitPrice = new Decimal(u.sell);

          cost += perUnitPrice.mul(allocationItem.numberUnitsPayingFor).toNumber();
        }
      });
    }

    return new Decimal(cost).dividedBy(!!allocationCategory.allocationLines ? allocationCategory.allocationLines : 1).toDecimalPlaces(2).toNumber();
  }

  static getTotalAllocationLines(allocationCatagories: PaymentAllocationCategory[]): number {
    let count = 0;

    allocationCatagories.forEach(cat => {
      if (cat.categoryName !== "Even Split")
        count += cat.allocationLines ? cat.allocationLines : 0;
    });

    return count;
  }

  static getGuestCount(reservationGuests: ReservationGuest[], allocationCategory: PaymentAllocationCategory | undefined): number {
    if (allocationCategory === undefined) return 0;

    let count = 0;
    reservationGuests.forEach(g => {
      if (g.paymentAllocationCategoryId === allocationCategory.paymentAllocationCategoryId && !g.cancelled)
        count++;
    })

    return count;
  }

  static getTotalAllocationsCost(allocationCatagories: PaymentAllocationCategory[], itinerary: Itinerary, reservationGuestsCount: number): number {
    let total = 0.0;

    allocationCatagories.forEach(cat => {
      total += new Decimal(PaymentAllocationCategory.getCost(cat, itinerary, reservationGuestsCount)).mul(cat.allocationLines ? cat.allocationLines : 0).toDecimalPlaces(2).toNumber();
    });

    return total;
  }
}